/**
 * components/hazard/SeveritySection.js — Эрсдэлийн түвшин сонгох хэсэг.
 *
 * Props:
 *   severities  : [{ level, name }] — DB-аас ачаалсан жагсаалт
 *   value       : level (1-5)
 *   onChange    : (level) => void
 *   showNotice  : Optional — доор green notice банер харуулах эсэх
 */
import React from "react";
import { Card, SectionTitle, SEV_COLOR } from "./common";

// ⚠ FontAwesome 5.11.2 нэр ашиглана. Өмнө нь FA6 нэр (fa-check-circle,
// fa-exclamation-triangle …) бичигдсэн байсан тул icon бүгд ХООСОН
// харагддаг байв. Шинэ icon нэмэхээсээ өмнө /risk/reference/checklist →
// «Кодчлол ба тэмдэглэгээ» таб дээрх шалгуураар нэрээ шалгаарай.
export const SEV_ICON = {
  1: "fa-check-circle",
  2: "fa-info-circle",
  3: "fa-exclamation-triangle",
  4: "fa-exclamation-circle",
  5: "fa-radiation",
};

// ⚠ ЯГ ГУРВАН ТҮВШИН — Бага · Дунд · Өндөр.
//   «Эрдэнэт үйлдвэр» ТӨҮГ эрсдэлийн түвшинг гурав гэж авч үздэг
//   (ХЭМАБМТ-02 журам 4.3.6). Урьд байсан «Их» (4), «Шууд аюул» (5)
//   нь журамд огт байхгүй бөгөөд нэг аюулыг хоёр хүн өөр өөрөөр
//   үнэлэхэд хүргэдэг байв.
export const DEFAULT_SEV = [
  { level: 1, name: "Бага" },
  { level: 2, name: "Дунд" },
  { level: 3, name: "Өндөр" },
];

export default function SeveritySection({
  severities,
  value = 2,
  onChange,
  showNotice = true,
}) {
  const sevList = Array.isArray(severities) && severities.length ? severities : DEFAULT_SEV;

  return (
    <Card>
      <SectionTitle>Эрсдэлийн түвшин</SectionTitle>
      <div style={{ display: "flex", gap: 6 }}>
        {sevList.map((s) => {
          const color = SEV_COLOR[s.level] || "#64748B";
          const active = value === s.level;
          const iconCls = SEV_ICON[s.level] || "fa-circle";
          return (
            <button
              key={s.level}
              type="button"
              onClick={() => onChange?.(s.level)}
              style={{
                flex: 1,
                padding: "10px 4px",
                borderRadius: 8,
                border: "1.5px solid " + (active ? color : "#E6E9EF"),
                background: active ? color : "#F7F8FA",
                color: active ? "#fff" : "#7A8496",
                fontSize: 11,
                fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.15s",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
              }}
            >
              <i className={"fas " + iconCls} style={{ fontSize: 16 }} />
              <span>{s.name}</span>
            </button>
          );
        })}
      </div>
      {showNotice && (
        <div
          style={{
            marginTop: 10,
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
            padding: "9px 11px",
            borderRadius: 9,
            background: "#EAF6EE",
            border: "1px solid #BEE3C8",
            fontSize: 12,
            color: "#1B7F3B",
            fontWeight: 600,
            lineHeight: 1.5,
          }}
        >
          <i className="fas fa-paper-plane" style={{ marginTop: 2 }} />
          <span>
            Таны оруулсан аюулын мэдээлэл нь таны АШУА болон ХАБЭАХ-н
            удирдлагад 3-5 секундын дотор илгээгдэнэ.
          </span>
        </div>
      )}
    </Card>
  );
}
